import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Detect if running inside HubSpot iframe
const isEmbedded = window !== window.parent;

// Send ready message to HubSpot parent frame when embedded
if (isEmbedded) {
  try {
    window.parent.postMessage({ type: 'APP_READY' }, 'https://app.hubspot.com');
    console.log('Sent APP_READY message to HubSpot parent frame');
  } catch (error) {
    console.error('Failed to send message to parent frame:', error);
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
